import { api } from "@/api/axios";
import { ApiOperationResult } from "@/types/common.types";
import { ApiHiringFlow, ApiHiringFlowCreate, ApiHiringFlowUpdate } from "@/types/hiring-flow.types";

export const apiHiringFlow = {
  list: () => api.get<ApiHiringFlow[]>("/api/v1/hiring-flows"),
  get: (id: number) => api.get<ApiHiringFlow>(`/api/v1/hiring-flows/${id}`),
  create: (payload: ApiHiringFlowCreate) =>
    api.post<ApiHiringFlow>("/api/v1/hiring-flows", payload),
  update: (id: number, payload: ApiHiringFlowUpdate) =>
    api.put<ApiHiringFlow>(`/api/v1/hiring-flows/${id}`, payload),
  archive: (id: number) => api.delete<ApiOperationResult>(`/api/v1/hiring-flows/${id}`),
};
